import { CountryISO } from "ngx-intl-tel-input";

export interface SaleConsignorModel {
  checkbox: boolean;
  consignorId: any;
  businessName: string;
  consignorContact: string;
  contactName: string;
  emailId: string;
  withdrawnCount: string;
  activeCount: string;
  xrayCount: string;
  scopeCount: string;
  surgeryReportCount: string;
  xrayReportCount: string;
  consignorDownloadLink: string
}

export enum SaleConsignorTableFields {
  BUSINESS_NAME = 'businessName',
  CONSIGNOR_CONTACT_NAME = 'consignorContact',
  CONTACT_NAME = 'contactName',
  EMAIL_ID = 'emailId',
  WITHDRAWN_COUNT = 'withdrawnCount',
  ACTIVE_COUNT = 'activeCount',
  XRAY_COUNT = 'xrayCount',
  SCOPE_COUNT = 'scopeCount',
  XRAY_REPORT_COUNT = 'xrayReportCount',
}
export interface ConsignorContact {
  consignorContactId: number;
  consignorId: number;
  firstName: string;
  lastName: string;
  emailAddress: string;
  phoneNumber: string;
  countryCode: string; // Required property
  selectedCountryISO?: string; // Optional or required, depending on your model
  isReceiveRepoEmail: boolean;
  isReceiveRepoSMS: boolean;
  internationalNumber?: any; // Optional, as it appears in your original code
}
